import { useEffect, useState } from "react";

export const useActiveSection = (sectionIds, options = {}) => {
  const [active, setActive] = useState(sectionIds[0] || "");
  const key = sectionIds.join("|");

  useEffect(() => {
    const ids = key ? key.split("|") : [];
    const sections = ids
      .map((id) => document.getElementById(id))
      .filter(Boolean);
    if (!sections.length || !("IntersectionObserver" in window)) return;

    const io = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible) setActive(visible.target.id);
      },
      {
        rootMargin: options.rootMargin || "-40% 0px -50% 0px",
        threshold: options.threshold || [0, 0.25, 0.5, 0.75, 1],
      }
    );
    sections.forEach((s) => io.observe(s));
    return () => io.disconnect();
  }, [key, options.rootMargin, options.threshold]);

  return active;
};
